import { render, staticRenderFns } from "./FreeCaseExtraFields.vue?vue&type=template&id=844f7ab4&"
import script from "./FreeCaseExtraFields.vue?vue&type=script&lang=js&"
export * from "./FreeCaseExtraFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports